module.exports = __webpack_public_path__ + "img/chess_checkersgreen.c371c6fc.png";